import EventType from '@/assets/enums/events/EventType.js'

/**
 * Event types that can be created from the Agenda/Planning without a dossier.
 */
export const EVENT_TYPES_WITHOUT_DOSSIER: readonly string[] = [
  EventType.OTHER,
  EventType.RECEPTION_DUTY,
  EventType.APPOINTMENT
]

/**
 * Event types that can be deleted from the Agenda/Planning event modal.
 */
export const DELETABLE_EVENT_TYPES: readonly string[] = [
  EventType.OTHER,
  EventType.RECEPTION_DUTY,
  EventType.APPOINTMENT
]

export function eventTypesWithoutDossier<T extends { id: string }>(
  eventTypeList: T[] | null | undefined
): T[] {
  return (eventTypeList ?? []).filter((eventType) =>
    EVENT_TYPES_WITHOUT_DOSSIER.includes(eventType.id)
  )
}

export function isEventDeletableFromAgenda(
  event: { id?: unknown; type?: string } | null | undefined
): boolean {
  if (!event?.id) return false

  return DELETABLE_EVENT_TYPES.includes(event.type)
}

/**
 * Type to keep once the dossier is removed from the event: types allowed without a
 * dossier are kept, dossier-only types fall back to "other".
 */
export function typeAfterDossierRemoved(currentType: string): string {
  if (EVENT_TYPES_WITHOUT_DOSSIER.includes(currentType)) return currentType

  return EventType.OTHER
}
